import { LioUserRole } from '@lio/rule-engine';
import { allRoles, internalRoles } from '@models/user';

import { PaymentPortalGuard } from '@router/PaymentPortalGuard';
import { IRoute } from '@router/routes/Route.interface';

import { lazy } from 'react';

const DashboardPage = lazy(() => import('../../pages/Payments').then((module) => ({ default: module.DashboardPage })));
const AccountManagementPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.AccountManagementPage })),
);
const AddAccountPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.AddAccountPage })),
);
const AlertsPage = lazy(() => import('../../pages/Payments').then((module) => ({ default: module.AlertsPage })));
const NewPaymentPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.NewPaymentPage })),
);
const PaymentDetailsPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.PaymentDetailsPage })),
);
const PaymentHistoryPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.PaymentHistoryPage })),
);
const AccountDetailsPage = lazy(() =>
  import('../../pages/Payments').then((module) => ({ default: module.AccountDetailsPage })),
);

const AccountStatementPaymentPage = lazy(
  () => import('../../pages/Payments/AccountStatementPayment/AccountStatementPaymentPage'),
);

const AutoPayEnrollmentsPage = lazy(() =>
  import('../../pages/Payments/AutoPayEnrollments/AutoPayEnrollmentsPage').then((module) => ({
    default: module.AutoPayEnrollmentsPage,
  })),
);
const AutoPayEnrollmentDetailPage = lazy(() =>
  import('../../pages/Payments/AutoPayEnrollmentDetail/AutoPayEnrollmentDetailPage').then((module) => ({
    default: module.AutoPayEnrollmentDetailPage,
  })),
);

const StatementCreditPage = lazy(() => import('../../pages/Payments/StatementCredits/StatementCreditPage'));

export const paymentRoutes: IRoute[] = [
  {
    roles: allRoles,
    path: 'payments',
    component: (
      <PaymentPortalGuard>
        <DashboardPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/accounts',
    component: (
      <PaymentPortalGuard>
        <AccountManagementPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/account/:accountId',
    component: (
      <PaymentPortalGuard>
        <AccountDetailsPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/add-account',
    component: <AddAccountPage />,
  },
  {
    roles: allRoles,
    path: 'payments/payment-history',
    component: (
      <PaymentPortalGuard>
        <PaymentHistoryPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: [LioUserRole.SrOps, LioUserRole.SystemAdmin, LioUserRole.PortalAdmin],
    path: 'payments/auto-pay-enrollment',
    component: (
      <PaymentPortalGuard>
        <AutoPayEnrollmentsPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: [LioUserRole.SrOps, LioUserRole.SystemAdmin, LioUserRole.PortalAdmin],
    path: 'payments/auto-pay-enrollment/:autoPayEnrollmentId',
    component: (
      <PaymentPortalGuard>
        <AutoPayEnrollmentDetailPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/payment-detail/:requestId',
    component: (
      <PaymentPortalGuard>
        <PaymentDetailsPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/new',
    component: (
      <PaymentPortalGuard>
        <NewPaymentPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    path: 'payments/alerts',
    component: (
      <PaymentPortalGuard>
        <AlertsPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: allRoles,
    // note: need both for now so i can do the lock, once accountStatement apis work we could remove billingAccountId and get from api
    path: 'payments/statement/:accountStatementId/new-payment',
    component: (
      <PaymentPortalGuard>
        <AccountStatementPaymentPage />
      </PaymentPortalGuard>
    ),
  },
  {
    roles: internalRoles,
    path: 'payments/statement-credit',
    component: (
      <PaymentPortalGuard>
        <StatementCreditPage />
      </PaymentPortalGuard>
    ),
  },
];
